import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

export const getBlacklistHistory = async (
  dispatch: Dispatch,
  query?: string,
) => {
  const url = `internal/blacklist/history?${query}`;
  const response = await requestHandler({
    method: 'get',
    url,
    dispatch,
  });
  if (response) return response.data;
};

export const getBlacklist = async (dispatch: Dispatch, query?: string) => {
  const url = `internal/blacklist/currently-blacklisted?${query}`;
  const response = await requestHandler({
    method: 'get',
    url,
    dispatch,
  });
  if (response) return response.data;
};

export const checkIfBusinessIsBlacklisted = async (
  dispatch: Dispatch,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/blacklist/business/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const addToBlacklist = async (
  dispatch: Dispatch,
  businessIdentifier: string,
  data: { reason: string; businessName: string },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/blacklist/business/${businessIdentifier}/add`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const removeFromBlacklist = async (
  dispatch: Dispatch,
  businessIdentifier: string,
  data: { reason: string },
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/blacklist/business/${businessIdentifier}/remove`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const updateBlacklist = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/blacklist/${data.id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const checkIfBusinessIsBlacklistedBatch = async (
  dispatch: Dispatch,
  identifiers: string[],
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/blacklist/business/checkBatch`,
    data: { identifiers },
    dispatch,
  });
  if (response) return response.data;
};
